import { ConstructorDestructorWrapper } from './ConstructorDestructor.styled';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { Accordion, AccordionItem, AccordionHeader, AccordionBody } from 'reactstrap';
import interviewQna from './../../../resources/content/interviewQna.png';
import { useState } from 'react';

function ConstructorDestructor() {

   const [open, setOpen] = useState('');
   const toggle = (id: any) => {
     if (open === id) {
       setOpen('');
     } else {
       setOpen(id);
     }
   };

   return(
      <ConstructorDestructorWrapper>
         <header className="entry-header">
            <h1 className="entry-title" itemProp="headline">Constructors &amp; Destructors</h1>			
         </header>
         <div className="entry-content clear" itemProp="text"  style={{height: 'auto !important'}}>
            <h4 className="text-align-justify">Constructor :</h4>
            <ul className="text-align-justify">
               <li>It is similar to a method, has the same name as the class name, but it does not have a return type.</li>
               <li>It gets called automatically when an instance of a class is created.</li>
               <li>When a constructor is called, memory is allocated to an object.</li>
               <li>In addition, if no constructor is present, the compiler will provide a default constructor.</li>
               <li>One can assign values to a class variable within a constructor.</li>
               <li>A constructor cannot be abstract, final, static, or synchronized.</li>
               <li>Access modifiers can be used in the constructor declaration to control which class can call it.</li>
               <li>Types of a constructor :
                  <ul>
                     <li>No argument constructor :
                        <ul>
                           <li>A default constructor is a constructor with no arguments.</li>
                           <li>If we don’t create a default constructor, the compiler will provide one.</li>
                           <li>The default values provided by the default constructor to the object like 0, null, etc.</li>
                           <li>Syntax – 
                              <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                                 {'<class_name>(){ }'}
                              </SyntaxHighlighter>
                           </li>
                        </ul>
                     </li>
                  </ul>
                  <ul>
                     <li>Parameterized constructor :
                        <ul>
                           <li>A constructor with parameters.</li>
                           <li>If we want to initialize parameters on our own, use a parameterized constructor.</li>
                           <li>Syntax – 
                              <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                              {
                                 '<class_name>(parameters) { \n'+
                                 '  //initialize parameters \n'+
                                 '}'
                              }
                              </SyntaxHighlighter>
                           </li>
                        </ul>
                     </li>
                  </ul>
               </li>
            </ul>
            <br/>
            <hr/>
            <br/>

            <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
            {
               '//Default Constructor\n'+
               '\n'+
               'class Person {\n'+
               '  int id;\n'+
               '  String name;\n'+
               '\n'+
               '  void display() {\n'+
               '    System.out.println(id + " " + name);\n'+
               '  }\n'+
               '  public static void main(String args[]) {\n'+
               '    //creating object\n'+
               '    Person person = new Person();\n'+
               '    person.display();\n'+
               '  }\n'+
               '}\n'+
               '\n'+
               'OUTPUT : 0 null'
            }
            </SyntaxHighlighter>
            <br/>
            <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
            {
               '//Parameterized Constructor\n'+
               '\n'+
               'class Person {\n'+
               '  int id;\n'+
               '  String name;\n'+
               '\n'+
               '  //parameterized constructor\n'+
               '  Person(int i, String n) {\n'+
               '    id = i;\n'+
               '    name = n;\n'+
               '  }\n'+
               '\n'+
               '  void display() {\n'+
               '    System.out.println(id + " " + name);\n'+
               '  }\n'+
               '  public static void main(String args[]) {\n'+
               '    //creating object\n'+
               '    Person person = new Person(1, Ram);\n'+
               '    person.display();\n'+
               '  }\n'+
               '}\n'+
               '\n'+
               'OUTPUT : 1 Ram'
            }
            </SyntaxHighlighter>
            
            <br/>
            <h4 className="text-align-justify">Destructor :</h4>
            <ul className="text-align-justify">
               <li>It is similar to a method, has the same name as the class name, but it does not have a return type or any parameters.</li>
               <li>When an object destroys, it calls the destructor automatically.</li>
               <li>When a destructor is called, it releases the memory assigned to the object and the resources.</li>
               <li>The finalize method present in the Object class invokes the destructor, but it’s not recommended as it’s not safe.</li>
               <li>There is no syntax for destructors in java because JVM handles it for you using automatic garbage collection. </li>
               <li>So, JVM will keep searching objects whose address is not present in any pointer, and its memory is released.</li>
            </ul>

            <div>
               <figure className="aligncenter size-large">
                  <img decoding="async" width="641" height="408" src={interviewQna} alt="" className="lazy-loaded" sizes="(max-width: 641px) 100vw, 641px"  />
               </figure>
            </div>

            <Accordion open={open} toggle={toggle}>
               <AccordionItem>
                  <AccordionHeader targetId="1">
                     <span className="fa fa-book"></span>
                     <span style={{marginLeft: '3vw'}}>What are constructors in java?</span>
                  </AccordionHeader>
                  <AccordionBody accordionId="1">
                     <p className="text-align-justify">A constructor is similar to a method, has the same name as the class name but it does not have a return type. It gets called automatically when an instance of a class is created. When a constructor is called, memory is allocated to an object.</p>
                  </AccordionBody>
               </AccordionItem>
            </Accordion>
         </div>
      </ConstructorDestructorWrapper>
   )
};

export default ConstructorDestructor;
